import React from 'react';

export default function Categories() {
  return (
    <div>
      <h3 className="text-center">Comming soon</h3>
    </div>
  );
}
